import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/working-slot";

export const pagingWorkingSlot = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getWorkingSlotById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = workingSlot => axios.post(API_PATH + '/save', workingSlot);

export const deleteWorkingSlot = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getListWorkingSlotByDate = (searchObject) => axios.post(API_PATH + "/list-by-date", searchObject);


